import { render, staticRenderFns } from "./TaskViewer.vue?vue&type=template&id=0be9bf08"
import script from "./TaskViewer.vue?vue&type=script&lang=js"
export * from "./TaskViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports